import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "../manage.css";

const availableAccess = [
  { value: "aktivitete", label: "Aktivitete (Posts)" },
  { value: "botime", label: "Botime" },
  { value: "ekspozita", label: "Ekspozita" },
  { value: "objekteMuzeale", label: "Objekte muzeale" },
  { value: "pozicioneVakante", label: "Pozicione vakante" },
  {
    value: "regjistriDokHumbura",
    label: "Regjistri i dokumenteve të humbura",
  },
  { value: "regjistriRhk", label: "Regjistri RHK" },
  { value: "revista", label: "Revista" },
  { value: "video", label: "Video" },
  { value: "user", label: "User" },
];

const EditRole = () => {
  const { id } = useParams();

  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [access, setAccess] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const fetchRole = async () => {
      try {
        setLoading(true);

        const token = localStorage.getItem("token");

        const response = await axios.get(
          `https://api.arkiva.gov.al/api/roles/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        setName(response.data.name || "");
        setAccess(response.data.access || []);
      } catch (error) {
        console.error("Error fetching role:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchRole();
  }, [id]);
  const handleAccessChange = (value) => {
    setAccess((prevAccess) => {
      if (prevAccess.includes(value)) {
        return prevAccess.filter((item) => item !== value);
      }

      return [...prevAccess, value];
    });
  };

  const validateForm = () => {
    const newErrors = {};

    if (!name.trim()) {
      newErrors.name = "Emri i rolit nuk mund të jetë bosh!";
    }

    if (access.length === 0) {
      newErrors.access = "Zgjidhni të paktën një menu!";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    try {
      setLoading(true);

      const token = localStorage.getItem("token");

      await axios.put(
        `https://api.arkiva.gov.al/api/roles/update/${id}`,
        {
          name,
          access,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      navigate("/manage/roles");
    } catch (error) {
      console.error("Error updating role:", error);

      alert(
        error.response?.data?.message ||
          "Ndodhi një gabim gjatë përditësimit të rolit.",
      );
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate("/manage/roles");
  };

  return (
    <div className="edit-page">
      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}

      <div className="return">
        <button onClick={handleCancel}>
          <i className="fa-solid fa-chevron-left"></i>
        </button>
      </div>

      <p>Edito Rol</p>

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="name">Emri i rolit</label>

          <input
            type="text"
            id="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />

          {errors.name && <small className="error">{errors.name}</small>}
        </div>

        <div className="form-group">
          <label>Aksesi</label>

          <div className="role-access-list">
            {availableAccess.map((item) => (
              <label key={item.value} className="role-access-item">
                <input
                  type="checkbox"
                  checked={access.includes(item.value)}
                  onChange={() => handleAccessChange(item.value)}
                />

                <span>{item.label}</span>
              </label>
            ))}
          </div>

          {errors.access && <small className="error">{errors.access}</small>}
        </div>

        <div className="edit-actions">
          <button type="submit" className="save">
            Ruaj ndryshimet
          </button>

          <button type="button" className="cancel" onClick={handleCancel}>
            Anullo
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditRole;
